import {Select} from "antd";
import styled from "styled-components";

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: ${props => (props.mb ? props.mb : "20px")};
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            width: 100%;
            font-size: 12px;
        }
    }
`;
